import React from 'react';
import { Flex } from 'antd-mobile';
import * as _ from 'lodash';
import cx from 'classnames';
import styles from './CommonBtnLess.modules.less';

export default (props) => {
  const {
    disabled, // 是否禁用
    onClick, // 点击事件
    style, // 样式
    className, // 类名
    title, // 标题
    children, // 子元素
    loading // 是否加载中
  } = props;

  const handleClick = _.throttle((e) => {
    onClick && onClick(e);
  }, 500);

  return (
    <Flex
      align="center"
      justify="center"
      style={style || {}}
      className={cx(
        styles.commonBtn,
        {
          [styles.disabled]: disabled
        },
        className
      )}
      onClick={(e) => {
        if (disabled) return;
        handleClick(e);
      }}>
      {!!loading && <div className={styles.loading} />}
      {!loading && !!title && <div className={styles.title}>{title}</div>}
      {!loading && !title && children}
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/pubBiz/CommonBtn/CommonBtnView.js